import React from "react";
import ResetPasswordForm from "./ResetPasswordForm";
import SignUpBanner from "../login/SignUpBanner";
import AuthBanner from "../../reusable/AuthBanner";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class resetPassword extends React.Component {
  render() {
    return (
      <div>
        <AuthBanner />
        <ResetPasswordForm />
        <SignUpBanner />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(resetPassword);



// WEBPACK FOOTER //
// ./src/pages/resetPassword/index.js